import type { FaireProductEntity } from "../../entity_types/product";

export const p_57hu4dvfkp: FaireProductEntity = {
  token: "p_57hu4dvfkp",
  type: "product",
  name: "18K Gold PVD Stainless Steel Lariat Necklace Double Ball Bead",
  brandToken: "b_99ch5ye698",
  brandName: "WJW",
  imageUrl:
    "https://cdn.faire.com/fastly/1a8c8134b223009e449fbd63ca2f7fa5d4ceac84697494ae33f68c0592f62154.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/3942730802ca02b5b2c48fc9e22cf68757765afd413b04b9b72cd9facc24ea37.jpeg",
    "https://cdn.faire.com/fastly/49a27f78b47d43192e297f9e11587709b119f8704cf6b6e0c364e6ad8cd9942c.jpeg",
    "https://cdn.faire.com/fastly/1ffa0f2a3ecacbe1469f3352b72bbfed7cad19f49055e85e4b400f954998d191.jpeg",
  ],
  priceDollars: 7.52,
  description:
    'Add a touch of elegance to any outfit with this Lariat Necklace Double Ball Bead. The lariat style, accented with double ball beads, creates a trendy and eye-catching effect that adds sophistication to any outfit. Perfect for layering or wearing solo, this necklace seamlessly transitions from day to night, appealing to a wide range of fashion tastes. Crafted from durable stainless steel with an 18K gold PVD finish, this necklace boasts a stunning gold look that is resistant to tarnishing and wear, ensuring long-lasting beauty.\n\n✦ 100% Waterproof, Non-tarnish, Hypoallergenic\n✦ Quality That Lasts\n✦ Designed for All Skin Types\n✦ Perfect for Every Budget\n\n- PVD COATING -\nWe use the process of PVD Coating our 18K Gold jewelry over 316L surgical grade stainless steel for a non-tarnish, hypoallergenic, polished finish that will hold up best to everyday wear and will never turn your customer\'s skin green.\n\nApprox. Length: 15"+18" + 4" Drop\nApprox. Weight: 5.6 grams',
  tags: [],
  msrpDollars: 67.72,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:57:46.296Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
